import { DetailsListLayoutMode, ICommandBarItemProps, Icon, TooltipHost } from "@fluentui/react";
import { TableComponent } from "../../../components/Table/TableComponent"
import { IButtonGroup, IColumn } from "../../../Interfaces/filter";
import themeBase from "../../../utils/theme/themeBase";
import { useState } from "react";
import { useBoolean } from "@fluentui/react-hooks";
import { PanelOperadorFiltro } from "./operadorFiltro/PanelOperadorFiltro";
import { UseOperador } from "./UseOperador";
import { IOperador, IOperadorDetalleRequest } from "../../../Interfaces/auxiliar/IOperador";
import { PanelHomologar } from "./homologar/PanelHomologar";
import { CabeceraTable } from "../../../components/Table/CabeceraTable";
import { TableBaseComponent } from "../../../components/Table/TableBaseComponent";
import IconHelper from "../../../utils/helpers/iconHelper";

const iconDetalleStyle: React.CSSProperties | undefined = {
    color: "#0078d4",
};

const Operador = () => {
    const [isOpenFiltrar, { setTrue: openPanelFiltrar, setFalse: closePanelFiltrar }] = useBoolean(false);
    const [isOpenHomologar, { setTrue: openPanelHomologar, setFalse: closePanelHomologar }] = useBoolean(false);


    const [codigoSync, setCodigoSync] = useState<IOperadorDetalleRequest>(null!);
    const [operador, setOperador] = useState<IOperador>({})
    const { items, filter, onChangeTake, _onkeyUpSearchTable, loading, pagination, handleResetUpdate, onChangeSearch } = UseOperador();

    const buttonLeft: ICommandBarItemProps[] = [
        {
            ...IconHelper.ICON_RELOAD,
            text: "Actualizar",
            onClick: () => {
                handleResetUpdate()
            },
        }
    ];

    // const buttonRight: ICommandBarItemProps[] = [
    //     {
    //         ...IconHelper.ICON_BS_FILTER,
    //         text: "Filtrar",
    //         onClick: () => {
    //             openPanelFiltrar()
    //         },
    //     }
    // ];

    function renderOpciones(item: IOperador) {
        return (
            <>
                <TooltipHost content={`Homologar`}>
                    <Icon
                        iconName="Sync"
                        className={themeBase.classNamesIcon.iconFont}
                        style={{ cursor: "pointer", color: "#0078d3" }}
                        onClick={() => {
                            setOperador(item)
                            openPanelHomologar()
                        }}
                    />
                </TooltipHost>
            </>
        );
    }

    const _columns = [
        {
            key: "numeracion",
            name: "N°",
            fieldName: "numeracion",
            minWidth: 30,
            maxWidth: 50,
            onRender: (item, index) => {
                const startIndex = (filter.skip ?? 0);
                return <>{startIndex + (index ?? 0) + 1}</>;
            }
        },
        {
            key: "codigoSync",
            name: "Código",
            fieldName: "codigoSync",
            minWidth: 100,
            maxWidth: 100,
        },
        {
            key: "operador",
            name: "Operador",
            fieldName: "operador",
            minWidth: 100,
            maxWidth: 200,
        },
        {
            key: "codigoRRHH",
            name: "CódigoSAP",
            fieldName: "codigoRRHH",
            minWidth: 100,
            maxWidth: 100,
        },
        {
            key: "nombreCompleto",
            name: "Nombres",
            fieldName: "nombreCompleto",
            minWidth: 100,
            maxWidth: 200
        },
        {
            key: "apellidoCompleto",
            name: "Apellidos",
            fieldName: "apellidoCompleto",
            minWidth: 100,
            maxWidth: 250,
        },
        {
            key: "opciones",
            name: "Opciones",
            minWidth: 2,
            maxWidth: 2,
            fieldName: "opciones",
            onRender: (item: IOperador) => renderOpciones(item)
        },
    ]

    return (
        <>

            <CabeceraTable
                Titulo={"Operadores"}
                SubTitulo={`Lista de Operadores de Equipos Auxiliares`}
                placeholder="Busca por Código"
                componentRef={onChangeSearch}
                onKeyUp={_onkeyUpSearchTable}
            />
            <TableBaseComponent
                leftBar={buttonLeft}
                rigthBar={[]}
                data={items}
                column={_columns}
                isLoading={loading}
                getPageSize={onChangeTake}
                pagination={pagination}
                layout={DetailsListLayoutMode.justified}
            />
            <PanelOperadorFiltro
                isOpen={isOpenFiltrar}
                onDismiss={closePanelFiltrar}
            />
            <PanelHomologar
                isOpen={isOpenHomologar}
                onDismiss={closePanelHomologar}
                operador={operador}
                reload={handleResetUpdate}
            />
        </>
    )
}

export { Operador }